import { fetchGraphQL } from "./libs";
const setProductDetail = async () => {
  const detailBody = document.querySelector('.p-detail-body'),
    container = document.querySelector('#js-p-detail-main-container');
  if (!detailBody || !detailBody.dataset.productWpId || !container) return false;

  const GET_POSTS = `
    {
      post(id: ${detailBody.dataset.productWpId}, idType: DATABASE_ID) {
        link
        productInfo {
          presentLimit
          feature {
            featureText
          }
        }
      }
    }
  `;

  const res = await fetchGraphQL(GET_POSTS, { first: 5 }),
    targetData = res.post,
    link = targetData.link,
    presentLimitData = targetData.productInfo.presentLimit,
    featureData = targetData.productInfo.feature;

  let html = ``;

  if (presentLimitData) {
    const date = new Date(presentLimitData);
    const today = new Date();
    const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
    const dateText = `${date.getMonth() + 1}月${date.getDate()}日（${weekdays[date.getDay()]}）`;
    date.setDate(date.getDate() + 1)
    let btnText;
    if (date > today) {
      btnText = `応募締め切り　${dateText}まで`;
    } else {
      btnText = `応募期間は終了しました`;
    }

    html += `
                <div class="p-detail-main__deadline">${btnText}</div>`;
  }

  if (featureData) {
    let featureItems = ``;
    featureData.forEach(data => {
      featureItems += `<li class="p-detail-main-feature__item">${data.featureText}</li>`;
    });

    html += `
                <div class="p-detail-main-feature">
                  <h2 class="p-detail-main-feature__heading">特集</h2>
                  <ul class="p-detail-main-feature__list">
                    ${featureItems}
                  </ul>
                </div>`;
  }

  html += `
                <div class="p-detail-main__btn">
                  <a href="${link}" class="c-btn-l-grn">詳細内容はこちら<i class="c-arrow-bg-grn"></i></a>
                </div>`;

  container.insertAdjacentHTML("beforeend", html)
};

export default setProductDetail;